import { SvgIcon } from '@mui/material';
import { FC } from 'react';

const Airline: FC = () => (
  <SvgIcon fontSize="inherit">
    <svg fill="none" version="1.1" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <g transform="matrix(.81057 0 0 .81057 -428 -30.415)">
        <path
          // eslint-disable-next-line max-len
          d="m557.34 59.62v-3.26c-3.42-3.05-11.34-8.11-12.05-8.63-0.15-4.16-0.59-8.7-1.81-9.8h-1.28c-1.22 1.1-1.65 5.64-1.81 9.8-0.71 0.51-8.62 5.57-12.05 8.63v3.26l12.24-4.13c0.2 2.07 0.49 3.97 0.79 5.99-0.27 0.15-1.21 1.16-3.97 3.58v1.81l5.44-1.81 5.44 1.81v-1.81c-2.76-2.42-3.7-3.43-3.97-3.58 0.3-2.01 0.59-3.91 0.79-5.99z"
          fill="currentColor"
        />
      </g>
    </svg>
  </SvgIcon>
);

export default Airline;
